
export const problemset = [
  {
    heading: "EMG-Controlled Robotic Hand Assist Device",
    paragraphs: [
      "Stroke and spinal cord injury (SCI) often result in upper-limb paralysis, limiting hand function and independence. Develop a low-cost, wearable robotic hand assist device that uses electromyography (EMG) signals to detect user intent and provide proportional grip assistance. The solution should incorporate force and angle sensing for real-time adaptive support and closed-loop control. Key challenges include improving EMG signal reliability, accommodating diverse hand geometries, and ensuring clinical usability. The final prototype should provide accurate, responsive, and affordable assistive hand movement for rehabilitation and daily use."
    ],
    bullets: []
  },
  {
    heading: "Low-Cost Multisensory Science Lab Modules",
    paragraphs: [
      "Develop frugal, classroom-ready assistive science kits that enable students with visual impairments to independently explore abstract scientific concepts through tactile and auditory feedback. The challenge focuses on creating low-cost, scalable learning tools such as tactile-audio circuit boards, light detectors, temperature indicators, and talking voltmeters (0–12V) that replace visual observations with accessible sensory cues. The solutions should align with school science curricula, be safe and easy to use in classroom settings, and promote inclusive hands-on learning of electricity, energy, heat, light, and measurement concepts."
    ],
    bullets: []
  },
  {
    heading: "Real-Time Classroom Captioning for Indian Languages",
    paragraphs: [
      "Design an offline, low-latency classroom captioning system for Hindi and English learning environments. The solution should include an on-device speech-to-text engine, a teacher-worn microphone, and a student-facing display application. Additional features may include automatic lecture summaries and note generation. The system must function without internet access, ensuring reliability in rural and low-connectivity settings while improving accessibility and participation for students with hearing impairments."
    ],
    bullets: []
  },
  {
    heading: "Visual Alert System for Home & Hostel Safety",
    paragraphs: [
      "Develop a modular safety alert system for hard-of-hearing users that detects important environmental sounds and converts them into accessible notifications. The system should recognize events such as doorbells, fire alarms, and emergency alerts, communicating them through flashlight signals, vibration alerts, or other visual indicators. The solution should be affordable, reliable, and easy to install in homes, hostels, and shared living spaces, enhancing safety, independence, and situational awareness."
    ],
    bullets: []
  },
  {
    heading: "Accessible Hostel/School Infrastructure Mapping Tool",
    paragraphs: [
      "Create a digital tool that evaluates and maps the accessibility of schools, hostels, and campuses. The system should assess ramps, door widths, pathways, slopes, and other mobility-related infrastructure. Using AI, the platform should generate an accessibility score and provide actionable insights for improvement. It should also support crowdsourced contributions to build a map of accessible routes and facilities, helping institutions create more inclusive environments."
    ],
    bullets: []
  },
  {
    heading: "Make STEM Concepts Accessible for Children with Cognitive and Visual Disabilities",
    paragraphs: [
      "Develop tactile, shape-based STEM manipulatives that make abstract mathematical and scientific concepts easier to understand for children with cognitive and visual disabilities. Participants will be provided with selected concepts that can be effectively represented through physical learning aids. The solution should focus on hands-on exploration, conceptual clarity, and accessibility. Prototypes must be durable, engaging, and suitable for classroom use, supporting inclusive STEM education through tactile learning."
    ],
    bullets: []
  },
  {
    heading: "AI-Based Tool for Conversion of Visual to Tactile Print-Ready Geometry Images",
    paragraphs: [
      "Develop an AI-powered tool that automatically converts visual geometry diagrams into simplified, tactile-ready line images suitable for embossers and swell-paper printing. The system should preserve essential geometric relationships while removing unnecessary visual clutter. Labels should be transformed into tactile-friendly markers or Braille representations, and outputs must comply with accessibility standards. The tool should enable teachers to generate tactile diagrams on demand and support equitable geometry learning for students with visual impairments."
    ],
    bullets: []
  },
  {
    heading: "Early-Childhood Disability-Inclusive Toolkits for Anganwadis and Rural Schools",
    paragraphs: [
      "Design a low-cost, inclusive toolkit that supports early learning, screening, and development in Anganwadis and rural schools. The toolkit may include tactile sensory play materials for shape recognition, textures, spatial understanding, fine motor skills, and early mathematics. It should also feature simple screening tools for visual tracking, sound localization, cognition, and motor development, supported by a mobile application and red-flag indicators. Additional components may include tactile number lines, textured counting aids, shape-sorting puzzles, and pattern-building activities."
    ],
    bullets: []
  },
  {
    heading: "Emotion & Communication Toolkit for Children with Disabilities",
    paragraphs: [
      "Develop an accessible communication and emotional-learning toolkit for children with autism, speech delay, intellectual disabilities, and blindness. The toolkit should help children recognize, express, and communicate emotions through tactile and multisensory methods. Possible components include tactile emotion tokens, emotion-story tiles combining characters, emotions, and situations, simple AAC boards with tactile symbols, and tactile emotional wheels. The solution should be intuitive, engaging, and adaptable across different disability groups while supporting emotional literacy and communication."
    ],
    bullets: []
  },
  {
    heading: "Tactile Chemistry Learning Kit",
    paragraphs: [
      "Design a safe, hands-on, non-chemical learning kit that helps children with learning disabilities and visual impairments understand chemical reactions and related concepts. The toolkit should explain reactants, products, reaction processes, sequencing, cause-and-effect relationships, and reaction types such as combination, decomposition, displacement, and acid-base reactions. Components may include tactile reaction tiles, tactile molecule models, reaction pathway boards, and textured patterns representing different reaction categories, making chemistry concepts tangible and accessible."
    ],
    bullets: []
  },
  {
    heading: "3D Tactile Models of South Indian Monuments with Audio Tours",
    paragraphs: [
      "Develop scaled 3D tactile models of two major South Indian monuments accompanied by accessible audio tours. The audio content should explain the monument’s layout, architecture, cultural significance, and historical context. Models must fit comfortably on a classroom desk while preserving key architectural features, spatial hierarchy, and overall layout. Structural elements such as walls, courtyards, towers, pathways, and water bodies should be distinguishable through touch. Designs should be optimized for low-material, rapid 3D printing without compromising tactile clarity."
    ],
    bullets: []
  },
  {
    heading: "PathPlay Cards: Tactile Games for Safe Mobility and Route Understanding",
    paragraphs: [
      "Create a set of tactile, game-based activity cards that help blind and low-vision children develop orientation and mobility skills through play. The cards should encourage obstacle detection, path following, turning, landmark identification, and basic route planning using a cane. Each card should present a tactile challenge, such as locating a doorway, avoiding obstacles, following a textured path, or navigating turns. Activities must be easy for teachers and parents to facilitate while building confidence, independence, and practical mobility skills."
    ],
    bullets: []
  },
  {
    heading: "Design an Independent Wardrobe & Dressing Toolkit for People with Visual Impairment",
    paragraphs: [
      "Create an affordable and intuitive solution that helps people with visual impairment identify, organize, match, and manage their clothing independently. Consider challenges related to outfit selection, wardrobe organization, and laundry management while ensuring the solution is practical, inclusive, and easy to integrate into everyday life."
    ],
    bullets: []
  }
];



export const deadlines = [
    {
        activity: "Release of Call for Participation",
        date: "1st June 2026 (Monday)"
    },
    {
        activity: "Last Date for Submitting Applications",
        date: "30th June 2026 (Tuesday)"
    },
    {
        activity: "Briefing Session for Interested Teams by Mentors",
        date: "5th July 2026 (Sunday)"
    },
    {
        activity: "First Review by Mentors",
        date: "26th July 2026 (Sunday)"
    },
    {
        activity: "Second Review by Mentors - Shortlisting of Teams",
        date: "6th September 2026 (Sunday)"
    },
    {
        activity: "Submission of Final Write-ups/Videos by Shortlisted Teams",
        date: "20th September 2026 (Sunday)"
    },
    {
        activity: "Presentation by shortlisted teams at EMPOWER 2026 and selection of winners",
        date: "4th October 2026 (Sunday)"
    }
]